import { render, staticRenderFns } from "./Discount25Modal.vue?vue&type=template&id=6c67b4d2&scoped=true"
import script from "./Discount25Modal.vue?vue&type=script&lang=js"
export * from "./Discount25Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67b4d2",
  null
  
)

export default component.exports